export class BDMatrixEliminationCategory {
  bdMatrixEliminationCategoryId: number;
  studySearchStrategyId: number;
  displayName: string;
  displayOrder: number;
  isActive: boolean;
  showInMasterMatrix: boolean;
}
